import { render, staticRenderFns } from "./TotalValueLocked.vue?vue&type=template&id=40af3cb0&"
import script from "./TotalValueLocked.vue?vue&type=script&lang=ts&"
export * from "./TotalValueLocked.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports